import React from 'react'
import { WbControlError, WbControlHint } from '@workbench/react/dist'
import { Field, FieldAttributes } from 'formik'
import { Radio } from 'components/inputs'
import { RadioProps } from 'components/inputs/Radio/Radio'
import { useTranslation } from 'react-i18next'

type RadioData = {
  label: string
  value: any
}

type RadioGroupFieldProps = {
  name: string
  radios: RadioData[]
  hint?: string
} & Partial<RadioProps> &
  JSX.IntrinsicElements['input']

export const RadioGroupField: React.FunctionComponent<RadioGroupFieldProps> = ({
  name,
  hint,
  radios,
  ...radioProps
}) => {
  const { t } = useTranslation()
  return (
    <Field name={name}>
      {({ field, meta, form }: FieldAttributes<any>) => (
        <>
          {radios.map((radio) => (
            <Radio
              key={`${name}-${radio.value}`}
              id={`${name}-${radio.value}`}
              {...field}
              {...radioProps}
              onChange={() => form.setFieldValue(name, radio.value)}
              value={radio.value}
              checked={field.value === radio.value}
              label={radio.label}
            />
          ))}

          {hint && <WbControlHint>{t(hint)}</WbControlHint>}
          {meta.touched && meta.error && (
            <WbControlError>{t(meta.error)}</WbControlError>
          )}
        </>
      )}
    </Field>
  )
}
